import React from "react";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus, LoanPeriod } from "constants/Constants";
import shallow from "zustand/shallow";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import { aprFromMoneyFactor } from "../../helperFunctions/LeaseFunctions";
import { Input, Label } from "reactstrap";
import NumberFormat from "react-number-format";

const MoneyFacInput = () => {
	const { lastEditedRate, leasePeriod, editField, moneyFactor } =
		useCurrentLeaseStore((state) => ({ ...state }), shallow);
	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);
	const periodPerYear = LoanPeriod[leasePeriod].term;
	const step = Math.pow(10, -4) / (2 * periodPerYear * 100);
	const handleMFChange = (e) => {
		if (lastEditedRate !== "MF") return;
		let mf = e.floatValue;
		mf = (Math.round(mf / step) * step).toFixed(8);
		editField("moneyFactor", mf);
		editField("apr", aprFromMoneyFactor(mf, periodPerYear) / 100);
		console.log("handleMFChange");
	};

	return (
		<>
			{/* <IntegerInput
				disableValidation
				value={lease.moneyFactor}
				onChange={handleMFChange}
				onFocus={() => lease.editField("lastEditedRate", "MF")}
				name="moneyFactor"
				label="Money Factor"
				type="number"
				colSize="col-sm-12"
				wholeRow={true}
				decimalScale={8}
				readOnly={type !== DealStatus.PENDING}
			/> */}

			<Label>Money Factor</Label>
			<NumberFormat
				name="moneyFactor"
				value={moneyFactor}
				wholeRow={true}
				decimalScale={8}
				fixedDecimalScale={true}
				onFocus={() => editField("lastEditedRate", "MF")}
				isNumericString={true}
				readOnly={type !== DealStatus.PENDING}
				customInput={Input}
				onValueChange={handleMFChange}
			/>
		</>
	);
};

export default MoneyFacInput;
